import { atom } from 'jotai';

export interface IPdfPreviewAtom {
  open: boolean;
  src: string;
  name?: string;
}

export const pdfPreviewAtom = atom<IPdfPreviewAtom | null>(null);
